import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CircularProgress, Box, Typography } from '@mui/material';
import { post } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';

function OAuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  useEffect(() => {
    const handleCallback = async () => {
      // Prevent multiple executions
      if (hasProcessed.current) return;
      hasProcessed.current = true;

      const code = searchParams.get('code');
      const error = searchParams.get('error');

      console.log('OAuth callback - Code:', code ? 'Present' : 'Missing', 'Error:', error);

      if (error) {
        console.error('OAuth error:', error);
        navigate('/?error=oauth_failed');
        return;
      }

      if (code) {
        try {
          console.log('Processing authorization code...');
          
          // Get the JWT token manually
          const session = await fetchAuthSession();
          const token = session.tokens?.idToken?.toString();
          
          console.log('JWT Token:', token ? 'Present' : 'Missing');
          
          const response = await post({
            apiName: 'reviewReplyApi',
            path: '/oauth/google',
            options: {
              body: { code },
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
              }
            }
          }).response;

          const data = await response.body.json();
          console.log('OAuth success:', data);
          navigate('/?connected=true');
        } catch (error) {
          console.error('OAuth failed:', error);
          navigate('/?error=oauth_failed');
        }
      } else {
        console.log('No code found, redirecting to home');
        navigate('/');
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 8 }}>
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        Connecting to Google...
      </Typography>
    </Box>
  );
}

export default OAuthCallback;
